import { useEffect, useState } from "react";
import { A, path } from "./Link";
import { TabIcon } from "./icons";
export function TabBar({variant}:{variant:"docked"|"floating"}) {
 const [keyboard,setKeyboard]=useState(false);
 useEffect(()=>{const resize=()=>setKeyboard(Boolean(visualViewport&&visualViewport.height<innerHeight*.75));visualViewport?.addEventListener("resize",resize);return()=>visualViewport?.removeEventListener("resize",resize)},[]);
 if(keyboard||location.pathname.startsWith("/case/"))return null;
 const tabs=[{to:"/",label:"지금",kind:"home"},{to:"/map",label:"지도",kind:"map"},{to:"/check",label:"문자 확인",kind:"sms"},{to:"/me",label:"내 동네",kind:"area"}] as const;
 return <nav className={`tab-bar ${variant}`} aria-label="하단 메뉴">{tabs.map(t=><A key={t.to} to={t.to} className={path()===t.to?"selected":""} aria-current={path()===t.to?"page":undefined}><TabIcon kind={t.kind}/><span>{t.label}</span></A>)}</nav>;
}
